import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { useSession } from "@/services/auth0/session";

const API_URL = import.meta.env.VITE_API_URL;

export interface ExternalCarrierArea {
  id: string;
  code: string;
  name: string;
  assignment: {
    id: string;
    active: boolean;
    serviceCoverages: Array<{ carrierServiceId: string; active: boolean }>;
  } | null;
}

export function useExternalCarrierAreas(carrierId: string) {
  const { token } = useSession();
  return useQuery({
    queryKey: ["external-carrier-areas", carrierId],
    enabled: !!token,
    queryFn: async () => {
      const { data } = await axios.get<{ data: ExternalCarrierArea[] }>(
        `${API_URL}/api/v2/admin/carriers/${carrierId}/service-areas`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      return data.data;
    },
  });
}

export function useSaveExternalCarrierArea(carrierId: string) {
  const { token } = useSession();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (args: {
      areaId: string;
      serviceCoverages: Array<{ carrierServiceId: string; active: boolean }>;
    }) => {
      const { data } = await axios.put(
        `${API_URL}/api/v2/admin/carriers/${carrierId}/service-areas/${args.areaId}`,
        { serviceCoverages: args.serviceCoverages },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      return data.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ["external-carrier-areas", carrierId],
      });
    },
  });
}
